let updateSizesTimer = null;
let ul = document.querySelector(".carousel-container ul");

window.location.pathname === "/west-midlands/" && (function() {
	let btnPrev = document.querySelector("#prev");
	let btnNext = document.querySelector("#next");

	btnPrev.addEventListener("click", e => {
		e.preventDefault();
		moveScroll(-1);
	});
	btnNext.addEventListener("click", e => {
		e.preventDefault();
		moveScroll(1);
	});

	ul.addEventListener("scroll", updateSizes);

	resetScroll();
})();

function resetScroll() {
	let middleLi = document.querySelector("li.middle");
	middleLi.scrollIntoView({block: 'nearest', inline: 'center'});
	document.querySelectorAll(".carousel-container li").forEach(li => {
		li.dataset["relX"] = li.offsetLeft;// - ul.scrollLeft;
	});
}

function moveScroll(dir) {
	const cardWidth = parseFloat(getComputedStyle(document.body).getPropertyValue('--size-card')) * 16;
	const gap = 32; // 2rem gap between cards
	const scrollAmount = (cardWidth + gap) * dir;

	console.log(cardWidth, scrollAmount);

	ul.scrollBy({
		left: scrollAmount,
		behavior: 'smooth'
	});
}

function updateSizes() {
	if(updateSizesTimer !== null) {
		return;
	}

	updateSizesTimer = setTimeout(() => {
		updateSizesTimer = null;
	}, 200);

	let scrollLeft = this.scrollLeft;

	ul.querySelectorAll("li").forEach(li => {
		// TODO: The diff is calculated from the left - calculate it from the centre, and then quantize it.
		let diffX = Math.abs(parseInt(li.dataset["relX"]) - scrollLeft);
		li.dataset["diffX"] = diffX;
	});
}
